module.exports = "https://static.wanderu.com/ui-react/_next/static/media/bus-grey.661497ce.svg";